// Shared calendar day pricing (desktop + mobile). GET calendar.json?hotel_pk=&mode=hotel|package.
kombi.calendarDayPrice = (function () {
    const MISSING_PRICE_LABEL = "---";

    let lastHotelPk = null;
    let lastCalendarUrl = null;
    let lastData = null;
    let fetchSeq = 0;

    function normalizeCalendarData(data) {
        if (!data || typeof data !== "object") {
            return null;
        }
        // Feature flag off / no rates → {} ; treat as no calendar for UI.
        if (Object.keys(data).length === 0) {
            return null;
        }
        return data;
    }

    function isPackageActive() {
        return (
            kombi.searchTabs &&
            typeof kombi.searchTabs.isPackageActive === "function" &&
            kombi.searchTabs.isPackageActive()
        );
    }

    function getMode() {
        return isPackageActive() ? "package" : "hotel";
    }

    function toDateKey(dateObj) {
        if (typeof kombi.fp_date_key === "function") {
            return kombi.fp_date_key(dateObj);
        }
        return "";
    }

    function formatPrice(value) {
        const amount = Number(value);
        if (!Number.isFinite(amount) || amount <= 0) {
            return "";
        }
        return new Intl.NumberFormat("pt-BR", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(Math.round(amount));
    }

    function buildUrl(calendarUrl, hotelPk, mode, refresh) {
        const url = new URL(calendarUrl, window.location.origin);
        url.searchParams.set("hotel_pk", String(hotelPk));
        url.searchParams.set("mode", mode || getMode());
        if (refresh) {
            url.searchParams.set("refresh", "1");
        }
        return url.toString();
    }

    function ensurePriceSlot(dayElement) {
        let priceEl = dayElement.querySelector(".calendar-day-price");
        if (!priceEl) {
            priceEl = document.createElement("span");
            priceEl.className = "calendar-day-price";
            priceEl.setAttribute("aria-hidden", "true");
            dayElement.appendChild(priceEl);
        }
        return priceEl;
    }

    function removePriceSlot(dayElement) {
        const priceEl = dayElement.querySelector(".calendar-day-price");
        if (priceEl) {
            priceEl.remove();
        }
    }

    // Package: no monetary value; best-price teal on the day number only.
    function decoratePackageDay(dayElement, calendarDay, canArrive) {
        removePriceSlot(dayElement);
        if (canArrive && calendarDay.is_best_price === true) {
            dayElement.classList.add("calendar-best-price");
        }
    }

    // Hotel: daily rate under the day number; keep the slot for cell alignment.
    function decorateHotelDay(dayElement, calendarDay, canArrive) {
        const priceEl = ensurePriceSlot(dayElement);
        priceEl.textContent = "";
        priceEl.classList.remove("calendar-day-price--best");

        if (!canArrive) {
            return;
        }

        if (calendarDay.is_best_price === true) {
            dayElement.classList.add("calendar-best-price");
            priceEl.classList.add("calendar-day-price--best");
        }

        priceEl.textContent = formatPrice(calendarDay.daily_price) || MISSING_PRICE_LABEL;
    }

    function decorateDayElement(dayElement, calendarDay, canArrive) {
        if (!dayElement) {
            return;
        }

        dayElement.classList.remove("calendar-best-price");

        if (isPackageActive()) {
            decoratePackageDay(dayElement, calendarDay, canArrive);
            return;
        }

        decorateHotelDay(dayElement, calendarDay, canArrive);
    }

    function applyToInstances(data) {
        (kombi.flatpickrInstances || []).forEach(function (fp) {
            fp.calendar = data;
            fp.redraw();
        });
        if (typeof kombi.syncAllCalendarLegendVisibility === "function") {
            kombi.syncAllCalendarLegendVisibility();
        }
        if (
            kombi.calendarMobile &&
            typeof kombi.calendarMobile.applyCalendarData === "function"
        ) {
            kombi.calendarMobile.applyCalendarData(data);
        }
    }

    function fetchCalendar(calendarUrl, hotelPk, mode, refresh) {
        const resolvedMode = mode || getMode();
        if (!hotelPk || !calendarUrl) {
            fetchSeq += 1;
            lastHotelPk = null;
            lastCalendarUrl = null;
            lastData = null;
            applyToInstances(null);
            return Promise.resolve(null);
        }

        const requestSeq = (fetchSeq += 1);
        const requestUrl = buildUrl(calendarUrl, hotelPk, resolvedMode, refresh);
        return fetch(requestUrl)
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Calendar request failed: " + response.status);
                }
                return response.json();
            })
            .then(function (data) {
                if (requestSeq !== fetchSeq) {
                    return lastData;
                }
                const normalized = normalizeCalendarData(data);
                lastHotelPk = hotelPk;
                lastCalendarUrl = calendarUrl;
                lastData = normalized;
                applyToInstances(normalized);
                return normalized;
            })
            .catch(function () {
                if (requestSeq !== fetchSeq) {
                    return lastData;
                }
                lastData = null;
                applyToInstances(null);
                return null;
            });
    }

    function refetchForCurrentMode() {
        if (!lastHotelPk || !lastCalendarUrl) {
            return Promise.resolve(null);
        }
        return fetchCalendar(lastCalendarUrl, lastHotelPk, getMode());
    }

    // Calendar open only: send refresh=1 so the backend may enqueue maybe_refresh.
    function refreshOnCalendarOpen() {
        if (!lastHotelPk || !lastCalendarUrl) {
            return Promise.resolve(null);
        }
        return fetchCalendar(lastCalendarUrl, lastHotelPk, getMode(), true);
    }

    return {
        toDateKey: toDateKey,
        decorateDayElement: decorateDayElement,
        fetchCalendar: fetchCalendar,
        refetchForCurrentMode: refetchForCurrentMode,
        refreshOnCalendarOpen: refreshOnCalendarOpen,
        getCachedData: function () {
            return lastData;
        },
        getLastHotelPk: function () {
            return lastHotelPk;
        },
        isPackageActive: isPackageActive,
    };
})();
